import { twMerge } from 'tailwind-merge';
import { match } from 'ts-pattern';
import Badge from './Badge';
import MediaDisplay from './MediaDisplay';

function Quantity({
  original,
  available,
}: {
  original?: number;
  available?: number;
}) {
  const hasAvailable = available !== undefined && original !== available;

  return original !== undefined ? (
    <>
      <span className="sr-only">Quantity</span>
      {hasAvailable && <span>{available} of</span>}
      <span>{original}</span>
    </>
  ) : (
    <>
      <span className="sr-only">Quantity none</span>
      <span>-</span>
    </>
  );
}

type Props = {
  alt: string | null;
  src?: string | null;
  quantity?: number;
  remainingReturnableQuantity?: number;
  variant?: 'regular' | 'small' | 'full';
  expandable?: boolean;
};

export default function ProductImage({
  src,
  alt,
  variant = 'regular',
  quantity,
  remainingReturnableQuantity,
  expandable = false,
}: Props) {
  const size = match(variant)
    .with('regular', () => 'size-20')
    .with('small', () => 'size-12')
    .with('full', () => 'size-full')
    .exhaustive();

  return (
    <div className="relative">
      <div
        data-component="corso-product-image"
        className={twMerge('rounded-lg', size)}
      >
        <MediaDisplay
          type="image"
          className={twMerge(size, 'rounded-[inherit]')}
          src={src ?? undefined}
          alt={alt ?? 'Product Image'}
          expandable={expandable}
        />
      </div>
      {quantity !== undefined && (
        <Badge className="absolute -top-2 -right-2">
          <Quantity
            original={quantity}
            available={remainingReturnableQuantity}
          />
        </Badge>
      )}
    </div>
  );
}
